"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CampaignInfluencerLinkMethods = exports.CampaignInfluencerLink = void 0;

var _strings = require("../../utils/strings");

var _product = require("../product");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var CampaignInfluencerLinkMethods = /*#__PURE__*/function () {
  function CampaignInfluencerLinkMethods() {
    _classCallCheck(this, CampaignInfluencerLinkMethods);
  }

  _createClass(CampaignInfluencerLinkMethods, null, [{
    key: "getLinkUrl",
    value: function getLinkUrl(campaignInfluencerLink) {
      return (0, _strings.decodeUTF8)(campaignInfluencerLink.target_url);
    }
  }, {
    key: "isProduct",
    value: function isProduct(campaignInfluencerLink) {
      return campaignInfluencerLink.link_type === 'product';
    }
  }, {
    key: "isDestination",
    value: function isDestination(campaignInfluencerLink) {
      return campaignInfluencerLink.link_type === 'destination';
    }
  }]);

  return CampaignInfluencerLinkMethods;
}();
/**
 * @deprecated - use the campaign influencer link methods instead
 * Represents a campaign link.
 */


exports.CampaignInfluencerLinkMethods = CampaignInfluencerLinkMethods;

var CampaignInfluencerLink = /*#__PURE__*/function () {
  function CampaignInfluencerLink(data) {
    _classCallCheck(this, CampaignInfluencerLink);

    Object.assign(this, data);

    if (this.campaign_product) {
      this.campaign_product = new _product.Product(this.campaign_product);
    }
  }

  _createClass(CampaignInfluencerLink, [{
    key: "getUrl",
    value: function getUrl() {
      return (0, _strings.decodeUTF8)(this.target_url);
    }
  }, {
    key: "isProduct",
    value: function isProduct() {
      return this.link_type === 'product';
    }
  }, {
    key: "isDestination",
    value: function isDestination() {
      return this.link_type === 'destination';
    }
  }]);

  return CampaignInfluencerLink;
}();

exports.CampaignInfluencerLink = CampaignInfluencerLink;